import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_DELAY_LINK,
  TEST_PURCHASE_FETCH_LINK_INFO_REQUEST,
} from '../../../actions/actionTypes';

const delayLink = fetchReducerGenerator(
  [TEST_PURCHASE_CLEAR, TEST_PURCHASE_FETCH_LINK_INFO_REQUEST],
  TEST_PURCHASE_DELAY_LINK
);

export default delayLink;
